<li *ngIf="details.label != 'LEFT_NAV.SUBNAV_ENVISION.EDATA_AND_INVENTORY_ALARMS'; else alarmContent" [id]="details.label">
  <a (click)="menuItemClick($event)" class="primary-blue-color-no-link font-12 font-bold LeftNavigation-link" [attr.href]="details?.href ? details?.href : null" [attr.target]="details?.target ? details?.target : null">{{details.label | translate}}</a>
</li>
<ng-template #alarmContent>
  <li *ngIf="(userType == 1 || userType == 2) && permissionPresent" [id]="details.label">
    <a (click)="menuItemClick($event)" class="primary-blue-color-no-link font-12 font-bold LeftNavigation-link" [attr.href]="details?.href ? details?.href : null" [attr.target]="details?.target ? details?.target : null">{{details.label | translate}}</a>
  </li>
</ng-template>
